/* unplugin-vue-components disabled */import { render } from "./Logo.vue?vue&type=template&id=1f99644e&scoped=true"
import script from "./Logo.vue?vue&type=script&lang=js"
export * from "./Logo.vue?vue&type=script&lang=js"

import "./Logo.vue?vue&type=style&index=0&id=1f99644e&lang=scss&scoped=true"

import exportComponent from "E:\\projects\\internation-fta-pc\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f99644e"]])

export default __exports__